import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ScoreSheetPages from '../components/print/ScoreSheetPages';
import { EventRound, HitsterEvent } from '../types';
import './PrintScoreSheet.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const PrintAllRoundsBooklet: React.FC = () => {
  const { eventId, roundId } = useParams<{ eventId: string; roundId: string }>();
  const navigate = useNavigate();

  const [event, setEvent] = useState<HitsterEvent | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/events/${eventId}`);
        if (response.ok) {
          const data: HitsterEvent = await response.json();
          setEvent(data);
        }
      } catch (error) {
        console.error('Failed to load event for all-rounds booklet:', error);
      }
      setLoading(false);
    };

    loadData();
  }, [eventId]);

  const rounds = useMemo(() => {
    if (!event) {
      return [];
    }

    return [...event.rounds]
      .filter((round: EventRound) => round.songs && round.songs.length > 0)
      .sort((left, right) => left.order - right.order);
  }, [event]);

  const teams = event?.teams || [];

  if (loading) return <div className="print-score-sheet loading">Laden...</div>;
  if (!event) return <div className="print-score-sheet error">Event niet gevonden</div>;
  if (teams.length === 0) return <div className="print-score-sheet error">Geen teams gevonden</div>;
  if (rounds.length === 0) return <div className="print-score-sheet error">Geen rondes met songs gevonden</div>;

  return (
    <div className="print-score-sheet">
      <div className="score-sheet-controls no-print">
        <button className="back-btn" onClick={() => navigate(`/round-scoring/${eventId}/${roundId}`)}>
          ← Terug
        </button>
        <h1>📚 Teamboekjes — alle rondes</h1>
        <div className="print-orientation-note">
          {teams.length} teams, {rounds.length} rondes, automatisch gegroepeerd per team.
        </div>
        <button className="print-btn" onClick={() => window.print()}>
          🖨️ Afdrukken
        </button>
        <div className="print-orientation-note">
          Dit boekje drukt alle rondes achter elkaar af voor elk team.
        </div>
      </div>

      <ScoreSheetPages event={event} rounds={rounds} teams={teams} />
    </div>
  );
};

export default PrintAllRoundsBooklet;
